<div class="d-print-none">
  <h2 i18n>Projet résidentiel</h2>
  <div>
    <form [formGroup]="formCalcul">
      <div class="mb-4">
        <!-- Emplacement du projet -->
        <h3 i18n>Emplacement du projet</h3>
        <div class="row mb-5">
          <div class="col-12">
            <div i18n>
              Indiquez l’emplacement de votre projet. Vous pouvez entrer un
              numéro de lot ou choisir un secteur.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-8">
            <div class="form-group">
              <label for="form-group-select" i18n>Type de recherche</label>
              <select
                class="form-control"
                name="form-group-select"
                id="form-group-select"
                formControlName="searchType"
                (change)="onChangeType($event)"
              >
                <option value="byCadastre" i18n>Par n° de lot</option>
                <option value="byTerritory" i18n>Par secteur</option>
              </select>
            </div>
          </div>
        </div>
        <ng-container *ngIf="formCalcul.value.searchType === 'byCadastre'">
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-8">
              <div class="form-group">
                <label for="form-control-input-default-icon" i18n
                  >N° de lot</label
                >
                <div class="input-group-icon input-group-icon-left">
                  <input
                    type="number"
                    class="form-control"
                    id="form-control-input-default-icon"
                    placeholder="1234567890"
                    formControlName="noCadastre"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="formCalcul.value.searchType === 'byTerritory'">
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-8">
              <div class="form-group">
                <div class="d-flex align-items-center mb-1">
                  <span class="label" i18n>Secteur</span>
                  <span
                    class="icon icon-help ml-auto"
                    aria-hidden="true"
                    (click)="showInfoModal('sector')"
                  ></span>
                </div>
                <select
                  class="form-control"
                  name="form-group-select"
                  id="selectSector"
                  formControlName="sector"
                  #s
                  (change)="onSectorClick(s.value)"
                  de
                >
                  <option></option>
                  <option
                    *ngFor="let sec of sectors; index as i"
                    [value]="sec.code"
                  >
                    {{ isEn ? sec.name.en : sec.name.fr }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- FIN Emplacement du projet -->

      <div class="mb-5">
        <!-- Caractéristiques du projet -->
        <h3 i18n>Ampleur du projet</h3>
        <div class="row mb-4">
          <div class="col-12">
            <span>
              <span i18n
                >Précisez la taille du projet. Le calcul tient compte du nombre
                de logements et de la superficie résidentielle totale du
                projet.</span
              >
              <span i18n> Consultez </span>
              <a [href]="usageLink" i18n>cette page</a>
              <span i18n>
                pour en apprendre davantage sur la méthode de calcul de la
                superficie résidentielle.</span
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-8">
            <div class="form-group">
              <label for="superficie" i18n
                >Superficie résidentielle totale</label
              >
              <input
                type="number"
                class="form-control"
                id="superficie"
                formControlName="superficie"
                aria-describedby="superficieHelp"
                placeholder="m²"
                min="0"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-8">
            <div class="form-group">
              <label for="nbAppartement" i18n>Nombre de logements</label>
              <input
                type="number"
                class="form-control"
                id="nbAppartement"
                formControlName="nbAppartement"
                aria-describedby="nbAppartementHelp"
                placeholder="0"
                min="0"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- FIN Caractéristiques du projet -->

      <hr />

      <div class="mb-5 mt-4">
        <button
          type="button"
          class="btn btn-primary btn-squared mr-2"
          [disabled]="!formCalcul.valid || isCalculating"
          (click)="handleCalculClick()"
        >
          <div *ngIf="isCalculating" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span i18n>Calculer</span>
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-squared"
          (click)="resetCalculator()"
        >
          <span i18n>Réinitialiser</span>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- PRINT  BLOCK -->
<div class="d-none d-print-block mb-2">
  <h2 class="mb-3" i18n>Projet résidentiel</h2>
  <h3 i18n>Emplacement du projet</h3>
  <div class="mb-3">
    <ng-container *ngIf="searchType.value === 'byCadastre'">
      <div class="d-flex">
        <span class="font-weight-bold mr-1" i18n>N° de lot</span>
        <span>{{ noCadastre.value }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="searchType.value === 'byTerritory'">
      <div class="d-flex mb-3">
        <span class="font-weight-bold mr-1" i18n>Secteur</span>
        <span>{{ sectorName }}</span>
      </div>
    </ng-container>
  </div>
  <h3 i18n>Ampleur du projet</h3>
  <div class="d-flex">
    <span class="font-weight-bold mr-1" i18n
      >Superficie résidentielle totale</span
    >
    <span>{{ superficie.value }} m²</span>
  </div>
  <div class="d-flex">
    <span class="font-weight-bold mr-1" i18n>Nombre de logements</span>
    <span>{{ nbAppartement.value }}</span>
  </div>
</div>

<div
  class="modal fade"
  [ngClass]="{ show: isShowInfoModal }"
  id="infoModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="infoModalLabel"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="infoModalLabel">{{ infoModalTitle }}</h5>
        <button
          type="button"
          class="btn-close close"
          aria-label="Close"
          (click)="handleInfoModalResponse()"
        >
          <span class="icon icon-x" aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body d-flex justify-content-center">
        <img class="infoFile" [src]="imageData" width="100%" />
      </div>
      <div class="modal-footer">
        <div class="modal-footer-buttons">
          <button
            type="button"
            class="btn btn-link"
            (click)="handleInfoModalResponse()"
            i18n
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
